module.exports = __webpack_public_path__ + "img/flower-group-2.85bb022.svg";